module.exports = __webpack_public_path__ + "static/media/points-portal3.829589c5.829589c5.JPG";